import RootStore from './RootStore';
import imApi from '../actions/im';

const tim = window.TIM.create({
  SDKAppID: '1400139918'
});
export type MsgImageIds = string | (string | number)[];
export interface MessageProps {
  type: string;
  current_gallery: number; // 新增照片所属的相册id
  gallery_id: number; //当前父相册id
  image_id: MsgImageIds;
}

export default class IMStore {
  rootStore: RootStore;
  listener = {} as {
    [key: string]: any[];
  };

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.initIMListener();
  }

  initIMListener() {
    tim.on(window.TIM.EVENT.MESSAGE_RECEIVED, this.onMessageReceived);
  }

  addMessageListener = (type: string, callback: any) => {
    if (!this.listener[type]) {
      this.listener[type] = [];
    }

    this.listener[type].push(callback);
  };

  removeMessageListener = (type: string, callback: any) => {
    let list = this.listener[type];

    if (list && list.length) {
      list = list.filter((it: any) => {
        if (it && it === callback) {
          return false;
        }
        return true;
      });

      this.listener[type] = list;
    }
  };

  invokeMessage = (type: string, data: any) => {
    let list = this.listener[type];
    if (list && list.length) {
      list.forEach((callback: any) => {
        if (callback && typeof callback == 'function') {
          callback(data);
        }
      });
    }
    // }else {
    //   // 没有监听的时候，直接去windows上发吧
    //   let event = new Event(`im_message_${type}`);
    //   event.data = data;
    //   window.dispatchEvent(event);
    // }
  };

  onMessageReceived = (e: any) => {
    let { data } = e;

    if (data && data.length) {
      data.forEach((it: any) => {
        if (it && it.type == 'TIMCustomElem') {
          let { payload } = it;
          console.log(`on message`, payload);
          if (payload && payload.data) {
            try {
              let message = JSON.parse(payload.data);
              if (
                message &&
                (message.gallery_id == window.gallery.id || message.ignore)
              ) {
                this.invokeMessage(message.type, message);
              }
            } catch (e) {}
          }
        }
      });
    }
  };

  generateNewUserNotice = () => {
    if (window.userinfo && !window.userinfo.is_mock) {
      let newUser = new Event('custom-comment-newuser-transition');
      newUser.data = {
        type: 'newuser',
        list: [{ nick_name: window.userinfo.nickname }]
      };

      window.userinfo.message_newuser = true;
      window.dispatchEvent(newUser);
    }
  };

  login() {
    return imApi.login().then(res => {
      return new Promise<void>((resolve, reject) => {
        if (res && res.code == 200) {
          let { data } = res;
          let { userid, sign } = data;

          let promise = tim.login({ userID: userid, userSig: sign });
          promise
            .then((imResponse: any) => {
              if (imResponse && imResponse.data.errorCode === 0) {
                this.generateNewUserNotice();
                resolve();
              } else {
                reject();
              }
            })
            .catch(function(imError: any) {
              console.warn('login error:', imError); // 登录失败的相关信息
              reject();
            });
        } else {
          reject();
        }
      });
    });
  }

  quitGroup(groupId: string = '@TGS#aGLT3ECGY') {
    return new Promise<void>((resolve, reject) => {
      let promise = tim.quitGroup(groupId);
      promise
        .then(function(imResponse: any) {
          console.log('退出群组成功', imResponse);
          resolve();
        })
        .catch((imError: any) => {
          console.log('退出群组失败', imError);
          reject();
        });
    });
  }

  isJoinedGroup(groupId: string = '@TGS#aGLT3ECGY') {
    return new Promise((resolve, reject) => {
      const readyNotice = () => {
        // let promise = tim.getGroupList();
        //
        // promise.then(function(imResponse) {
        //
        //   resolve(true);
        // }).catch(function(imError) {
        //   console.warn('getGroupList error:', imError); // 获取群组列表失败的相关信息
        //   reject();
        // });
        tim.off(window.TIM.EVENT.SDK_READY, readyNotice);

        resolve(true);
      };
      tim.on(window.TIM.EVENT.SDK_READY, readyNotice);
    });
  }

  joinGroup(groupId: string = '@TGS#aGLT3ECGY') {
    return new Promise<void>((resolve, reject) => {
      this.isJoinedGroup(groupId).then(() => {
        let promise = tim.joinGroup({
          groupID: groupId,
          type: window.TIM.TYPES.GRP_AVCHATROOM
        });
        promise
          .then((imResponse: any) => {
            console.log('申请加群的调试信息', imResponse);
            if (imResponse) {
              switch (imResponse.data.status) {
                case window.TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL: // 等待管理员同意
                  break;
                case window.TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
                  console.log(imResponse.data.group); // 加入的群组资料
                  break;
                case window.TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
                  // 已经在群中的时候，应该要给踢下线才对，然后再重新加入一下，否则可能会发送到之前的连接上，从而收不到消息
                  this.quitGroup().then(() => {
                    console.log('退出后再重新进入');
                    tim.joinGroup({
                      groupID: groupId,
                      type: window.TIM.TYPES.GRP_AVCHATROOM
                    });
                  });
                  break;
                default:
                  break;
              }

              resolve();
            }
          })
          .catch(function(imError: any) {
            console.warn('joinGroup error:', imError); // 申请加群失败的相关信息
            reject();
          });
      });
    });
  }
}
